module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-top'), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "category-breadcrumb"
  }, [_c('router-link', {
    staticClass: "category-breadcrumb-default",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Category',
        query: {
          levelOne: '',
          levelTwo: '',
          levelThree: '',
          keyWord: '',
          selectType: '',
          brandId: ''
        }
      }
    }
  }, [_vm._v("全部商品")]), _vm._v(" "), _vm._l((_vm.category), function(item, index) {
    return _c('span', [(item.deep == 1) ? _c('router-link', {
      staticClass: "category-breadcrumb-default",
      attrs: {
        "tag": "a",
        "to": {
          name: 'Category',
          query: {
            levelOne: item.id,
            levelTwo: '',
            levelThree: '',
            keyWord: '',
            selectType: '',
            brandId: ''
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : (item.deep == 2) ? _c('router-link', {
      staticClass: "category-breadcrumb-default",
      attrs: {
        "tag": "a",
        "to": {
          name: 'Category',
          query: {
            levelOne: _vm.category[index - 1].id,
            levelTwo: item.id,
            levelThree: '',
            keyWord: '',
            selectType: '',
            brandId: ''
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : (item.deep == 3) ? _c('router-link', {
      staticClass: "category-breadcrumb-default",
      attrs: {
        "tag": "a",
        "to": {
          name: 'Category',
          query: {
            levelOne: _vm.category[index - 2].id,
            levelTwo: _vm.category[index - 1].id,
            levelThree: item.id,
            keyWord: '',
            selectType: '',
            brandId: ''
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1)
  }), _vm._v(" "), _c('a', {
    staticClass: "category-breadcrumb-default category-breadcrumb-last"
  }, [_vm._v("商品详情")])], 2), _vm._v(" "), (!_vm.isBlack) ? _c('div', [_c('div', {
    staticClass: "detail-goods-info productContent"
  }, [_c('div', {
    staticClass: "detail-goods-img"
  }, [_c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "swiper-container gallery-top"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.goodsInfo.goodsNavigateList), function(item, index) {
    return _c('div', {
      staticClass: "swiper-slide",
      class: {
        'active-nav': index == 0
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.navigateImage
      },
      on: {
        "error": function($event) {
          return _vm.error(1)
        }
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }, [_c('div', {
    staticClass: "arrow-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-container gallery-thumbs"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.goodsInfo.goodsNavigateList), function(item, index) {
    return _c('div', {
      staticClass: "swiper-slide",
      class: {
        'active-nav': index == 0
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.navigateImage
      },
      on: {
        "error": function($event) {
          return _vm.error(1)
        }
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "one-dowload"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.oneDowload
    }
  }, [_vm._v("一键下载商品素材")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail-goods-text",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "detail-goods-code"
  }, [_vm._v("\n              商品编码：\n              "), _c('span', [_vm._v(_vm._s(_vm.goodsInfo.goodsCode))])]), _vm._v(" "), (_vm.goodsInfo.channel == 1) ? _c('div', {
    staticClass: "detail-goods-title channel-mendian"
  }, [_vm._v(_vm._s(_vm.goodsInfo.goodsName))]) : (_vm.goodsInfo.channel == 2) ? _c('div', {
    staticClass: "detail-goods-title channel-dianshang"
  }, [_vm._v(_vm._s(_vm.goodsInfo.goodsName))]) : _c('div', {
    staticClass: "detail-goods-title channel-haitao"
  }, [_vm._v(_vm._s(_vm.goodsInfo.goodsName))]), _vm._v(" "), _c('div', {
    staticClass: "detail-goods-name"
  }, [_vm._v("\n              品牌名称：\n              "), _c('span', {
    staticStyle: {
      "color": "rgba(53,53,53,1)"
    }
  }, [_vm._v(_vm._s(_vm.goodsInfo.brandName))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-goods-name"
  }, [_vm._v("\n              所属分类：\n              "), _vm._l((_vm.category), function(item, index) {
    return _c('span', [(item.deep == 1) ? _c('router-link', {
      staticClass: "category-breadcrumb-default",
      attrs: {
        "tag": "a",
        "to": {
          name: 'Category',
          query: {
            levelOne: item.id,
            levelTwo: '',
            levelThree: '',
            keyWord: '',
            selectType: '',
            brandId: ''
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : (item.deep == 2) ? _c('router-link', {
      staticClass: "category-breadcrumb-default",
      attrs: {
        "tag": "a",
        "to": {
          name: 'Category',
          query: {
            levelOne: _vm.category[index - 1].id,
            levelTwo: item.id,
            levelThree: '',
            keyWord: '',
            selectType: '',
            brandId: ''
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : (item.deep == 3) ? _c('router-link', {
      staticClass: "category-breadcrumb-default",
      attrs: {
        "tag": "a",
        "to": {
          name: 'Category',
          query: {
            levelOne: _vm.category[index - 2].id,
            levelTwo: _vm.category[index - 1].id,
            levelThree: item.id,
            keyWord: '',
            selectType: '',
            brandId: ''
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "detail-goods-price"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "类似专柜价/吊牌价/厂商指导价",
      "placement": "top"
    }
  }, [_c('span', [_vm._v("划线价：")])]), _vm._v(" "), _c('span', {
    staticClass: "detail-goods-price-num"
  }, [_vm._v(_vm._s(_vm.goodsInfo.suggestPrice ? '¥' + _vm.goodsInfo.suggestPrice / 100 : ''))])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-goods-time"
  }, [_vm._v("\n              上架时间：\n              "), _c('span', {
    staticStyle: {
      "color": "rgba(53,53,53,1)"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.goodsInfo.onLineTime))]), _vm._v("\n                至\n                "), _c('span', [_vm._v(_vm._s(_vm.goodsInfo.offLineTime))])])]), _vm._v(" "), (_vm.goodsInfo.openingTime) ? _c('div', {
    staticClass: "detail-goods-time",
    staticStyle: {
      "color": "#fea923"
    }
  }, [_vm._v("\n              开售时间：\n              "), _c('span', {
    staticStyle: {
      "color": "#fea923"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.goodsInfo.openingTime))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-goods-btn-default"
  }, [(_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 2) ? [(_vm.bhskc == true) ? _c('span', {
    staticClass: "bg-color-gray cursor-pointer"
  }, [_vm._v("暂无库存")]) : (!_vm.isNoTaxActive) ? _c('span', {
    staticClass: "bg-color-red cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.addGoodsAll(0)
      }
    }
  }, [_vm._v("一键不带票上架")]) : _c('span', {
    staticClass: "bg-color-gray cursor-pointer"
  }, [_vm._v("一键不带票上架")])] : _vm._e(), _vm._v(" "), (_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 1) ? [(_vm.hskc == true) ? _c('span', {
    staticClass: "bg-color-gray cursor-pointer"
  }, [_vm._v("暂无库存")]) : (!_vm.taxActive) ? _c('span', {
    staticClass: "bg-color-orange cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.addGoodsAll(1)
      }
    }
  }, [_vm._v("一键带票上架")]) : _c('span', {
    staticClass: "bg-color-gray cursor-pointer"
  }, [_vm._v("一键带票上架")])] : _vm._e(), _vm._v(" "), (true) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "添加商品报价至报价篮子，可以批量导出商品报价",
      "placement": "top",
      "popper-class": "custom-width"
    }
  }, [_c('span', {
    staticClass: "cursor-pointer",
    staticStyle: {
      "color": "#fea923",
      "border": "1px solid #fea923"
    },
    on: {
      "click": _vm.getPrice
    }
  }, [_vm._v("获取报价")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "detail-bottom-info"
  }, [_vm._v("一键上架：把带票/不带票的所有有效SKU全部拉入货架")])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "detail-brandInfo"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "detail-brandInfo-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgAddress + _vm.brand.backgroundImagePath
    },
    on: {
      "error": function($event) {
        return _vm.error(3)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "deatil-brand-logo",
    attrs: {
      "src": _vm.imgAddress + _vm.brand.logoPath
    },
    on: {
      "error": function($event) {
        return _vm.error(4)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-brandInfo-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.brand.nameEn))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.brand.nameCn))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-brandInfo-interduce"
  }, [_c('div', [_vm._v(_vm._s(_vm.brand.descriptions))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-brandInfo-link"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Category',
        query: {
          levelOne: '',
          levelTwo: '',
          levelThree: '',
          keyWord: '',
          selectType: '',
          brandId: _vm.brand.brandId
        }
      }
    }
  }, [_vm._v("走进品牌")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-allGoods-line"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.goodsInfo.whetherPriceControl == 1) ? _c('div', {
    staticClass: "price-control"
  }, [_c('span', {
    staticClass: "price-control-tips"
  }, [_vm._v("零售控价")]), _vm._v("\n          该商品品牌方控价，请不要低于建议售价对外销售，擅自降价将会终止供应链供货！\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tableNewInfo.generalPro.length > 0) ? _c('div', {
    staticClass: "detail-table-box"
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "detail-table-th"
  }, [_c('tr', [_c('th', {}, [_vm._v("规格")]), _vm._v(" "), (_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 2) ? [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('th', [_vm._v("不带票库存")]), _vm._v(" "), _c('th', [_vm._v("操作")])] : _vm._e(), _vm._v(" "), (_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 1) ? [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('th', [_vm._v("带票库存")]), _vm._v(" "), _c('th', [_vm._v("操作")])] : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.tableNewInfo.generalPro), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "detail-table-firsttd"
    }, [_c('img', {
      staticStyle: {
        "width": "45px",
        "height": "45px"
      },
      attrs: {
        "src": item.imagePath
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.specName))])]), _vm._v(" "), (_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 2) ? [_c('td', {
      staticClass: "table-detail-center"
    }, [_vm._v("¥" + _vm._s(item.noTaxProductVo ? item.noTaxProductVo.salePrice / 100 : '--'))]), _vm._v(" "), _c('td', {
      staticClass: "table-detail-center",
      staticStyle: {
        "width": "236px"
      }
    }, [(item.noTaxProductVo) ? [_c('div', [_c('span', [_vm._v(_vm._s(item.noTaxProductVo ? '¥' + item.noTaxProductVo.settlementPrice / 100 : '--'))]), _vm._v(" "), _c('span', {
      staticClass: "table-detail-gray"
    }, [_vm._v("(+" + _vm._s(item.noTaxProductVo ? item.noTaxProductVo.freight / 100 : '--') + ")")])]), _vm._v(" "), _c('div', {
      staticClass: "table-detail-area-box"
    }, [(item.noTaxProductVo.refuseArea.length > 0) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.noTaxProductVo.refuseArea2,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "table-detail-area"
    }, [_vm._v("不配送区域")])]) : _vm._e(), _vm._v(" "), (item.noTaxProductVo.specialFee.length > 0) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.noTaxProductVo.specialFee2,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "table-detail-specialarea"
    }, [_vm._v("特殊地区运费")])]) : _vm._e()], 1)] : [_c('div', [_vm._v("--")])]], 2), _vm._v(" "), _c('td', {
      staticClass: "table-detail-center"
    }, [_vm._v(_vm._s(item.noTaxProductVo ? item.noTaxProductVo.inventoryNum : '--') + "\n                  "), (item.isSelf == 1) ? _c('div', {
      staticStyle: {
        "color": "rgb(88, 191, 106)",
        "border-radius": "12px",
        "width": "60px",
        "height": "18px",
        "border": "1px solid",
        "font-size": "12px",
        "margin": "0 auto"
      }
    }, [_vm._v("自产自销")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "table-detail-center"
    }, [(!item.noTaxProductVo || item.noTaxProductVo.inventoryNum == 0) ? _c('div', {
      staticClass: "detail-table-button disalbe-button-grey",
      on: {
        "click": function($event) {
          return _vm.onAddShelves(1, 0, item.productId)
        }
      }
    }, [_vm._v("暂无库存")]) : (item.noTaxProductVo.shelves == 1) ? _c('div', {
      staticClass: "detail-table-button disalbe-button-grey"
    }, [_vm._v("已加入货架")]) : _c('div', {
      staticClass: "detail-table-button",
      on: {
        "click": function($event) {
          return _vm.onAddShelves(1, 0, item.productId)
        }
      }
    }, [_vm._v("加入货架")])])] : _vm._e(), _vm._v(" "), (_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 1) ? [_c('td', [_vm._v(_vm._s(item.taxProductVo ? '¥' + item.taxProductVo.salePrice / 100 : '--'))]), _vm._v(" "), _c('td', [(item.taxProductVo) ? [_c('div', [_c('span', [_vm._v(_vm._s(item.taxProductVo ? '¥' + item.taxProductVo.settlementPrice / 100 : '--'))]), _vm._v(" "), _c('span', {
      staticClass: "table-detail-gray"
    }, [_vm._v("(+" + _vm._s(item.taxProductVo ? item.taxProductVo.freight / 100 : '--') + ")")])]), _vm._v(" "), _c('div', {
      staticClass: "table-detail-area-box"
    }, [(item.taxProductVo.refuseArea.length > 0) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.taxProductVo.refuseArea2,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "table-detail-area"
    }, [_vm._v("不配送区域")])]) : _vm._e(), _vm._v(" "), (item.taxProductVo.specialFee.length > 0) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.taxProductVo.specialFee2,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "table-detail-specialarea"
    }, [_vm._v("特殊地区运费")])]) : _vm._e()], 1)] : [_c('div', [_vm._v("--")])]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.taxProductVo ? item.taxProductVo.inventoryNum : '--') + "\n                  "), (item.isSelf == 1) ? _c('div', {
      staticStyle: {
        "color": "rgb(88, 191, 106)",
        "border-radius": "12px",
        "width": "60px",
        "height": "18px",
        "border": "1px solid",
        "font-size": "12px",
        "margin": "0 auto"
      }
    }, [_vm._v("自产自销")]) : _vm._e()]), _vm._v(" "), _c('td', [(!item.taxProductVo || item.taxProductVo.inventoryNum == 0) ? _c('div', {
      staticClass: "detail-table-button disalbe-button-grey",
      on: {
        "click": function($event) {
          return _vm.onAddShelves(1, 1, item.productId)
        }
      }
    }, [_vm._v("暂无库存")]) : (item.taxProductVo.shelves == 1) ? _c('div', {
      staticClass: "detail-table-button disalbe-button-grey"
    }, [_vm._v("已加入货架")]) : _c('div', {
      staticClass: "detail-table-button",
      on: {
        "click": function($event) {
          return _vm.onAddShelves(1, 1, item.productId)
        }
      }
    }, [_vm._v("加入货架")])])] : _vm._e()], 2)
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.tableNewInfo.communityPro.length > 0) ? _c('div', {
    staticClass: "detail-table-box",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._m(7), _vm._v(" "), _c('table', {
    staticClass: "detail-table-th"
  }, [_c('tr', [_c('th', {}, [_vm._v("规格")]), _vm._v(" "), (_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 2) ? [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('th', [_vm._v("不带票库存")]), _vm._v(" "), _c('th', [_vm._v("操作")])] : _vm._e(), _vm._v(" "), (_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 1) ? [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('th', [_vm._v("带票库存")]), _vm._v(" "), _c('th', [_vm._v("操作")])] : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.tableNewInfo.communityPro), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "detail-table-firsttd"
    }, [_c('img', {
      staticStyle: {
        "width": "45px",
        "height": "45px"
      },
      attrs: {
        "src": item.imagePath
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.specName))])]), _vm._v(" "), (_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 2) ? [_c('td', {
      staticClass: "table-detail-center"
    }, [_vm._v("¥" + _vm._s(item.noTaxProductVo ? item.noTaxProductVo.salePrice / 100 : '--'))]), _vm._v(" "), _c('td', {
      staticClass: "table-detail-center",
      staticStyle: {
        "width": "236px"
      }
    }, [(item.noTaxProductVo) ? [_c('div', [_c('span', [_vm._v(_vm._s(item.noTaxProductVo ? '¥' + item.noTaxProductVo.settlementPrice / 100 : '--'))])]), _vm._v(" "), _c('div', {
      staticClass: "table-detail-area-box"
    }, [(item.noTaxProductVo.refuseArea.length > 0) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.noTaxProductVo.refuseArea2,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "table-detail-area"
    }, [_vm._v("不配送区域")])]) : _vm._e(), _vm._v(" "), (item.noTaxProductVo.specialFee.length > 0) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.noTaxProductVo.specialFee2,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "table-detail-specialarea"
    }, [_vm._v("特殊地区运费")])]) : _vm._e()], 1)] : [_c('div', [_vm._v("--")])]], 2), _vm._v(" "), _c('td', {
      staticClass: "table-detail-center"
    }, [_vm._v(_vm._s(item.noTaxProductVo ? item.noTaxProductVo.inventoryNum : '--') + "\n                  "), (item.isSelf == 1) ? _c('div', {
      staticStyle: {
        "color": "rgb(88, 191, 106)",
        "border-radius": "12px",
        "width": "60px",
        "height": "18px",
        "border": "1px solid",
        "font-size": "12px",
        "margin": "0 auto"
      }
    }, [_vm._v("自产自销")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "table-detail-center"
    }, [(!item.noTaxProductVo || item.noTaxProductVo.inventoryNum == 0) ? _c('div', {
      staticClass: "detail-table-button disalbe-button-grey",
      on: {
        "click": function($event) {
          return _vm.onAddShelves(2, 0, item.productId)
        }
      }
    }, [_vm._v("暂无库存")]) : (item.noTaxProductVo.shelves == 1) ? _c('div', {
      staticClass: "detail-table-button disalbe-button-grey"
    }, [_vm._v("已加入货架")]) : _c('div', {
      staticClass: "detail-table-button",
      on: {
        "click": function($event) {
          return _vm.onAddShelves(2, 0, item.productId)
        }
      }
    }, [_vm._v("加入货架")])])] : _vm._e(), _vm._v(" "), (_vm.goodsTaxDisplayType == 0 || _vm.goodsTaxDisplayType == 1) ? [_c('td', [_vm._v(_vm._s(item.taxProductVo ? '¥' + item.taxProductVo.salePrice / 100 : '--'))]), _vm._v(" "), _c('td', [(item.taxProductVo) ? [_c('div', [_c('span', [_vm._v(_vm._s(item.taxProductVo ? '¥' + item.taxProductVo.settlementPrice / 100 : '--'))])]), _vm._v(" "), _c('div', {
      staticClass: "table-detail-area-box"
    }, [(item.taxProductVo.refuseArea.length > 0) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.taxProductVo.refuseArea2,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "table-detail-area"
    }, [_vm._v("不配送区域")])]) : _vm._e(), _vm._v(" "), (item.taxProductVo.specialFee.length > 0) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.taxProductVo.specialFee2,
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "table-detail-specialarea"
    }, [_vm._v("特殊地区运费")])]) : _vm._e()], 1)] : [_c('div', [_vm._v("--")])]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.taxProductVo ? item.taxProductVo.inventoryNum : '--') + "\n                  "), (item.isSelf == 1) ? _c('div', {
      staticStyle: {
        "color": "rgb(88, 191, 106)",
        "border-radius": "12px",
        "width": "60px",
        "height": "18px",
        "border": "1px solid",
        "font-size": "12px",
        "margin": "0 auto"
      }
    }, [_vm._v("自产自销")]) : _vm._e()]), _vm._v(" "), _c('td', [(!item.taxProductVo || item.taxProductVo.inventoryNum == 0) ? _c('div', {
      staticClass: "detail-table-button disalbe-button-grey",
      on: {
        "click": function($event) {
          return _vm.onAddShelves(2, 1, item.productId)
        }
      }
    }, [_vm._v("暂无库存")]) : (item.taxProductVo.shelves == 1) ? _c('div', {
      staticClass: "detail-table-button disalbe-button-grey"
    }, [_vm._v("已加入货架")]) : _c('div', {
      staticClass: "detail-table-button",
      on: {
        "click": function($event) {
          return _vm.onAddShelves(2, 1, item.productId)
        }
      }
    }, [_vm._v("加入货架")])])] : _vm._e()], 2)
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-goods-line"
  }), _vm._v(" "), _vm._l((_vm.goodsInfo.goodsDetailList), function(item) {
    return _c('div', [_c('div', {
      staticClass: "detail-goods-bimage"
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.imagePath
      },
      on: {
        "error": function($event) {
          return _vm.error(1)
        }
      }
    })])])
  })], 2) : _c('div', {
    staticClass: "invisible-message-wrap"
  }, [_c('div', {
    staticClass: "invisible-message-box"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "desc-box",
    attrs: {
      "onselectstart": "return false"
    }
  }, [(_vm.isBlackContent == 1) ? _c('p', [_vm._v("抱歉，该商品暂未授权")]) : _vm._e(), _vm._v(" "), (_vm.isBlackContent == 2) ? _c('p', [_vm._v("抱歉, 该商品已经下架")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("还有更多好货可供您挑选")])]), _vm._v(" "), _c('div', {
    staticClass: "return-pre-btn",
    style: ({
      'background': _vm.colorMain
    }),
    on: {
      "click": _vm.returnPre
    }
  }, [_vm._v("去挑好货")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "width": "600px",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "category-goods-add-default",
    staticStyle: {
      "width": "200px",
      "margin": "0 auto"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("我知道了")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-brandInfo-title"
  }, [_c('span', [_vm._v("品牌介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-title"
  }, [_vm._v("\n          货品列表\n          "), _c('span', {
    staticClass: "inner_box"
  }, [_vm._v("(带票库存可开发票,不带票无发票)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("一件代发")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('div', [_vm._v("不带票")]), _vm._v(" "), _c('div', [_vm._v("建议售价")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {}, [_c('div', [_vm._v("不带票")]), _vm._v(" "), _c('div', [_vm._v("结算价（+基础运费）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {}, [_c('div', [_vm._v("带票")]), _vm._v(" "), _c('div', [_vm._v("建议售价")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {}, [_c('div', [_vm._v("带票")]), _vm._v(" "), _c('div', [_vm._v("结算价（+基础运费）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("社群集采")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('div', [_vm._v("不带票")]), _vm._v(" "), _c('div', [_vm._v("建议售价")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {}, [_c('div', [_vm._v("不带票")]), _vm._v(" "), _c('div', [_vm._v("                结算价                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {}, [_c('div', [_vm._v("带票")]), _vm._v(" "), _c('div', [_vm._v("建议售价")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {}, [_c('div', [_vm._v("带票")]), _vm._v(" "), _c('div', [_vm._v("            结算价          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-cry"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/red_cry.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f039a29c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Detail.vue
// module id = 548
// module chunks = 1